import React from 'react';
import TableSettingsView from '../../../../../shared/TableSettings/TableSettingsView';
import { ProductMasterDataTableSettingsColumn } from '../../../../../../types/table_settings/pmd/ProductMasterDataTableSettings';
import { EntityType } from '../../../../../../types/comment';
import { CustomFieldEntityType } from '../../../../../../types/custom_field';
import { translate } from '../../../../../../types/translation/Translator';
import { TranslationKey } from '../../../../../../types/translation/TranslationKey';

export default function ProductMasterDataTableSettingsPane() {
  return (
    <div className='content-x'>
      <TableSettingsView<ProductMasterDataTableSettingsColumn>
        type={EntityType.pmd}
        customFieldEntityType={CustomFieldEntityType.productMasterData}
        availableColumns={Object.values(ProductMasterDataTableSettingsColumn)}
        columnTextBuilder={item => translate({ key: item })}
        label={translate({ key: TranslationKey.addProductReferenceColumn })}
        placeholder={translate({ key: TranslationKey.addProductReferenceColumn })}
      />
    </div>
  );
}
